import { render } from "./index.vue?vue&type=template&id=f53de3ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f53de3ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f53de3ee"

export default script